import { FiPlus } from "react-icons/fi";
import SwingLibraryMini from "./SwingLibraryMini";
import { useState } from "react";
import Button from "../../../../../../../components/shared/Button/Button";
import { useNewton } from "../../../store/NewtonContext";
import Popover from "../../../../../../../components/shared/Popover/Popover";

const AddSwingsBtn = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { attachedFiles, videoFile } = useNewton();

  const isDisabled = !!videoFile || attachedFiles.length > 0;

  const close = () => setIsOpen(false);

  return (
    <Popover
      align="start"
      containerClassName="relative"
      contentClassName=""
      isOpen={isOpen}
      onClose={close}
      side="top"
      trigger={
        <Button
          className="text-primary200 flex items-center gap-2"
          color="grayTrue700"
          isDisabled={isDisabled}
          onClick={() => setIsOpen((v) => !v)}
          rounded="lg"
          size="sm"
          type="button"
        >
          Add swings <FiPlus className="size-4" />
        </Button>
      }
    >
      <div
        className="rounded-lg"
        style={{
          height: 500,
          minHeight: 500,
          minWidth: 450,
          width: 450,
        }}
      >
        <SwingLibraryMini onClose={close} />
      </div>
    </Popover>
  );
};

export default AddSwingsBtn;
